import { useEffect, useRef, useState } from "react"
import LineChart from "../../Components/highChart/new/NewBarChartDefault"
import { listaColoresChart } from "../../Components/shared/colores";
import * as XLSX from 'xlsx';
import Select from 'react-select';
import { getEcenariosFuente, getEmpresasFuente, getFuenteGrafico, getGraficoDataEspontanea, getGraficoPagina, getGraficoRankingSemana, getGraficoSemana, getRankingSemana, getSemanasPersonajes } from '../../services/service';
import highchartsSeriesLabel from 'highcharts/modules/series-label'; // Importar el módulo series-label
import Highcharts from 'highcharts'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Loading from "../../Components/shared/Loading/Loading";
import ts from "typescript";

const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        padding: 4,
        fontSize: 12,
    }),
    multiValue: (base: any, state: any) => {
        return { ...base, fontSize: 11 };
    },
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition, fontSize: 14};
    }
};


interface DataObject {
    Orden: string;
    Empresa: string;
    Candidatos: string;
    [key: string]: string; // Allow for dynamic keys for date columns
  }
  

const GraficoRankingSemana = () => {
    const divRef = useRef(null);

    const  [categories, setCategories] = useState([])
    const [data, setdata] = useState({tituloProps:'',subtitleProps:'',selectValueProsp:[],formatDataStringData:'%',disableFilterProps:true,numDecimalProps:0,pieTextProps:'Se muestran las 5 categorías con mayor porcentaje.',showPieTextInGraph:true,showLineTop:true,showSeries:true,bottonLegend:true,sharedLegend:false})
    const [arrayColores, setArrayColores] = useState(listaColoresChart);
    const [apiData, setApiData] = useState([]);
    const [stateLoading, setstateLoading] = useState(false)
    const [valuesSelected, setValuesSelected] = useState([]);
    const [categoiesValue, setCategoiesValue] = useState([]);

    const [valueData,setValuesData]=useState<any[]>()
    //@ts-ignore
    const [valueOptionsFuente, setvalueOptionsFuente] = useState<any>({value:'',label:''});
   

    highchartsSeriesLabel(Highcharts);


    const exportToPDF = () => {
        const element = document.getElementById('element-to-export');
    //@ts-ignore
        html2canvas(divRef.current).then(canvas => {
          const pdf = new jsPDF('p', 'mm', 'a4');
          pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 210, 100);
          pdf.save('Personaje_semana.pdf');
        });}
    const {tituloProps,subtitleProps,selectValueProsp,formatDataStringData,disableFilterProps,
        numDecimalProps,
        pieTextProps,
        showPieTextInGraph,
        showLineTop,
        showSeries,
        bottonLegend,
        sharedLegend} = data
        

        const handleCapture = () => {
            if (divRef.current) {
              html2canvas(divRef.current).then(canvas => {
                // Generar imagen base64
                const imgData = canvas.toDataURL('image/png');
                // Crear un enlace para descargar la imagen
                const link = document.createElement('a');
                link.download = 'Personajes_semanas.png';
                link.href = imgData;
                link.click();
              });
            }
          };
        const exportExcel = (params: any) => {
            //Creo un nuevo excel
            const wb = XLSX.utils.book_new();
    
            //Se setean los datos al formato para el excel
            const data = XLSX.utils.json_to_sheet(setDataGraficoForExcel(apiData));
    
            //Se crea una pagina por cada cada grafico con sus respectivos datos
            XLSX.utils.book_append_sheet(wb, data, 'Grafico');
    
            //Se descarga el excel
            XLSX.writeFile(wb, "Data " + "Grafico" + ".xlsx")
        }
        const setDataGraficoForExcel = (data: any) => {
            let arrayAux: any = [];
            
            const newvalue =data.map((item: any) => {

                return {empresa:item.empresa,escenario:item.escenario,candidato:item.candidatos,...item.data}


            })

           return newvalue
        }


        const onChangeSelectFuente = async (value: any,arrayCategory?:any[]) => {
            console.log(value)
            setstateLoading(true)
            setvalueOptionsFuente(value)
            let categoria: any = [value.label]
            setCategories(categoria)
            await getGraficoRankingSemana(value.value).then((r:any) =>{
                let graphData = r.data.data.map((item:any) => {
                    return {name:item.personaje,data:[item.valor]}
                })
                console.log(graphData);
                
                setValuesData(graphData)
            })


            setstateLoading(false)
            
            


            

        }

        const cargarDats = async () =>{
          setstateLoading(true)
            await getRankingSemana().then((r:any) =>{
                
                setCategoiesValue(r.data.data)

                onChangeSelectFuente(r.data.data.at(-1))
           


                  })

                  setstateLoading(false)
    
        }
        
  

        useEffect(() => {   
            
            cargarDats()
            
        
      
            
            

        }, [])
        
   
   
    return (
        <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className={`d-flex justify-content-center border-top-graph`} >
            <div className="bg-body rounded chart-content mt-3">
      {stateLoading ? <Loading loading={stateLoading} /> : null}

              <div className="d-flex gap-2">
              <div className="flex1">
              <Select
                 className="react-select-container flex1"
                 
                 classNamePrefix="react-select "
                    placeholder="Seleccionar..."
                    styles={customStyles}
                    closeMenuOnSelect={true}
                    options={categoiesValue}
                    //@ts-ignore
                    onChange={(e)=>onChangeSelectFuente(e,null)}
                    value={valueOptionsFuente}
                />
</div>


               
              </div>

                <div ref={divRef} className='mt-3 container-graphLine'>
                    <LineChart
                        allData={valueData}
                        title={'Ranking de la semana'}
                        subtitle={''}
                        mostrarlegend={true}
                        showCategory={false}
                        sharedLegend={sharedLegend}
                        bottonLegend={bottonLegend}
                        numDecimalProps={numDecimalProps}
                        pieTextProps={pieTextProps}
                        showSeries={showSeries}
                        formatDataStringData={formatDataStringData}
                        showPieTextInGraph={showPieTextInGraph}
                        labels={categories}
                        colores={arrayColores}
                        exportExcel={exportExcel}
                        exportarImagen={handleCapture}
                        exportpdf={exportToPDF}
                        activeButton={true}
                    />
                </div>
             
            </div>
              {/* <ChartV5 /> */}
            </div>
          </div>
        </div>
      </div>
    )
}

export default GraficoRankingSemana